
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminosycondiciones-soyinmobiliaria",
      function () {
        return require("private-next-pages/terminosycondiciones-soyinmobiliaria/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminosycondiciones-soyinmobiliaria"])
      });
    }
  